export default __webpack_public_path__ + "static/1736166809764-e08b11e09b5d58d4e50e1fe98344c50c.jpeg";